module.exports = __webpack_public_path__ + "static/media/ice22.5a9e148e.webp";